import { AccountingModelModel } from 'src/app/models/management/accounting-model.model';

export class AccountingModelDetailModel {
  accountingModelDetailId: number = 0;
  accountingModelId: number = 0;
  accountingModel: AccountingModelModel = new AccountingModelModel();
  conceptInvoicingId: number = 0;
  familyId: number | null = null;
  articleId: number | null = null;
  salesAccount: string | null = null;
  salesReturnAccount: string | null = null;
  accountingCostCenter: string | null = null;
  createDate: string = '';
  userNameCreate: string = '';
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
